/**
 * Bliss & Birch - Collection Editorial & Read More Accordion Handler
 * Handles 1-line truncation with Read More/Read Less toggle and FAQ accordions.
 */

window.bbToggleReadMore = function(btn) {
  var target = btn.previousElementSibling;
  if (!target) return;
  var isExpanded = target.classList.toggle('is-expanded');
  btn.textContent = isExpanded ? 'Read less' : 'Read more';
  btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
};

window.toggleFaq = function(element) {
  var faqItem = element.closest('.faq-item') || element.parentElement;
  if (!faqItem) return;
  var icon = faqItem.querySelector('.faq-icon');
  var isOpen = faqItem.classList.toggle('open');
  if (icon) {
    icon.textContent = isOpen ? '−' : '+';
  }
};

function bbInitCollectionReadMore() {
  var selectors = [
    '.collection-hero__description',
    '.custom-blog-content',
    '.fan-chandelier-header p',
    '.luxury-header p',
    '.marble-header p',
    '.artistic-header p'
  ];

  selectors.forEach(function(sel) {
    var elements = document.querySelectorAll(sel);
    elements.forEach(function(el) {
      if (el.dataset.bbReadMoreInit) return;
      el.dataset.bbReadMoreInit = 'true';

      var text = el.textContent ? el.textContent.trim() : '';
      if (!text || text.length < 40) return;

      el.classList.add('bb-clamped-content');

      // Check if button already exists right after element
      var next = el.nextElementSibling;
      if (next && next.classList && next.classList.contains('bb-read-more-toggle')) {
        return;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bb-read-more-toggle';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.onclick = function() {
        window.bbToggleReadMore(this);
      };

      el.parentNode.insertBefore(btn, el.nextSibling);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bbInitCollectionReadMore);
} else {
  bbInitCollectionReadMore();
}
